exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-15d795d4] {\n  font-weight: normal;\n  margin-top: 12px !important;\n}\n", ""]);

// exports
